import { render, staticRenderFns } from "./EventsDashboardCard.vue?vue&type=template&id=7291906c"
import script from "./EventsDashboardCard.vue?vue&type=script&lang=js"
export * from "./EventsDashboardCard.vue?vue&type=script&lang=js"
import style0 from "./EventsDashboardCard.vue?vue&type=style&index=0&id=7291906c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports